export default class AddressUtil {
    static concatWithCommas(...items: string[]) {
        return `${items[0] || '[No City]'}, ${items[1] || '[No State]'} ${items[2] || '[No Zip]'}`;
    }
}



// WEBPACK FOOTER //
// ./src/util/Address.ts